import { useState, useEffect } from "react";
import axios from "axios";

type DrawDateResult = {
  date: string;
  day: string;
};

type UseDrawDatesReturn = {
  drawDates: string[];
  drawDays: string[];
  isLoading: boolean;
  error: string | null;
};

export const useDrawDates = (): UseDrawDatesReturn => {
  const [drawDates, setDrawDates] = useState<string[]>([]);
  const [drawDays, setDrawDays] = useState<string[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchDrawDates = async () => {
      try {
        const endpoint = process.env.REACT_APP_ENDPOINT as string;
        const response = await axios.get(`${endpoint}/api/results/all`);

        const results: DrawDateResult[] = response.data;

        // Filter out invalid entries and deduplicate by date
        const seenDates = new Set<string>();
        const uniqueResults = results.filter((r) => {
          if (!r.date || r.date === "" || seenDates.has(r.date)) {
            return false;
          }
          seenDates.add(r.date);
          return true;
        });

        // Sort by date descending (most recent first)
        // Date format is DD-MM-YYYY
        const sortedResults = uniqueResults.sort((a, b) => {
          const [dayA, monthA, yearA] = a.date.split("-").map(Number);
          const [dayB, monthB, yearB] = b.date.split("-").map(Number);

          const dateA = new Date(yearA, monthA - 1, dayA);
          const dateB = new Date(yearB, monthB - 1, dayB);

          return dateB.getTime() - dateA.getTime();
        });

        setDrawDates(sortedResults.map((r) => r.date));
        setDrawDays(sortedResults.map((r) => r.day));
        setIsLoading(false);
      } catch (err) {
        setError("Failed to fetch draw dates");
        setIsLoading(false);
      }
    };

    fetchDrawDates();
  }, []);

  return { drawDates, drawDays, isLoading, error };
};
